// Mock data for Brewing Frames website

export const navigationLinks = [
  { name: 'HOME', path: '/' },
  { name: 'WORK', path: '/work' },
  { name: 'OUR TEAM', path: '/directors' },
  { name: 'ABOUT US', path: '/about' }
];

export const socialLinks = [
  { name: 'Instagram', icon: 'instagram', url: 'https://instagram.com' },
  { name: 'Vimeo', icon: 'video', url: 'https://vimeo.com' },
  { name: 'LinkedIn', icon: 'linkedin', url: 'https://linkedin.com' }
];

export const services = [
  'TVC',
  'DIGITAL',
  'CAMPAIGNS',
  'WEB',
  'VIDEO SERIES',
  'ANIMATION',
  'MUSIC VIDEOS',
  'SHOWS',
  '3D & CGI',
  'SPECIAL EFFECTS'
];

export const newReleases = [
  {
    id: 1,
    title: 'Brand Campaign Film',
    videoId: 'vdGNgIkRbj4',
    thumbnail: 'https://img.youtube.com/vi/vdGNgIkRbj4/maxresdefault.jpg'
  },
  {
    id: 2,
    title: 'Commercial Production',
    videoId: 'zCq7yXmSfGg',
    thumbnail: 'https://img.youtube.com/vi/zCq7yXmSfGg/maxresdefault.jpg'
  },
  {
    id: 3,
    title: 'Show Reel 2024',
    videoId: 'Va4LTvJiCnQ',
    thumbnail: 'https://img.youtube.com/vi/Va4LTvJiCnQ/maxresdefault.jpg',
    isShowReel: true
  }
];

export const partners = [
  { name: 'Facebook', logo: '/Facebook.png' },
  { name: 'Boat', logo: '/boat.png' },
  { name: 'Taco Bell', logo: '/taco bell.png' },
  { name: 'Sabyasachi', logo: '/Sabyasachi.png' },
  { name: 'Vistara', logo: '/Vistara.png' },
  { name: 'Flipkart', logo: '/flipcart.png' },
  { name: 'JSW', logo: '/jsw.png' },
  { name: 'HP', logo: '/hp.png' },
  { name: 'DeHaat', logo: '/dehaat.png' },
  { name: 'ScoopWhoop', logo: '/scoop.png' },
  { name: 'Kalpa-Taru', logo: '/Kalpa-Taru.png' },
  { name: 'Philips', logo: '/Philips.png' },
  { name: 'Reckitt', logo: '/Reckitt.png' },
  { name: 'Magnetic Fields', logo: '/Magnetic Fields.png' },
  { name: 'Garnier', logo: '/Garnier.png' },
  { name: 'Britannia', logo: '/Britannia.png' },
  { name: 'Loreal', logo: '/Loreal.png' },
  { name: 'PWC', logo: '/pwc.png' },
  { name: 'Bira', logo: '/Bira.png' },
  { name: 'JW Marriott', logo: '/JW Marriott.png' },
  { name: 'Vision11', logo: '/Vision11.png' },
  { name: 'Manish Malhotra', logo: '/manish .png' },
  { name: 'NFDC', logo: '/nfdc.png' },
  { name: 'ORF', logo: '/orf.png' }
];

export const originalFilm = {
  title: 'AWARD WINNING FILM',
  subtitle: 'ORIGINALS',
  videoId: 'Va4LTvJiCnQ',
  thumbnail: 'https://img.youtube.com/vi/Va4LTvJiCnQ/maxresdefault.jpg'
};

export const heroVideo = {
  // Local hero video file
  url: '/hero-video (1).mp4',
  fallbackImage: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=1920&q=80'
};

export const companyInfo = {
  name: 'Brewing Frames',
  tagline: 'ELEVATE YOUR BRAND WITH',
  heroTitle: ['IMMERSIVE', 'FILMS'],
  description: 'An award-winning production house creating immersive brand experiences through compelling films.',
  founded: '2015',
  founders: ['John Smith', 'Jane Doe']
};
